import api from '@/utils/api';

const state = {
    cnyOptions: [],
};

const getters = {
    cnyOptions: (state) => state.cnyOptions,
};

const actions = {
    updateCnyOptions({ commit }) {
        return new Promise((resolve, reject) => {
            api({ url: 'Tool/GetCurrencyOptions', data: null, method: 'GET' })
                .then((resp) => {
                    commit('update_cnyOptions', resp.data.options);
                    resolve(resp);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};

const mutations = {
    update_cnyOptions(state, options) {
        state.cnyOptions = options;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
